import type { LoaderOptions } from '@/loaders/LoaderOptions';

import { getServiceProtocolByKeyQueryOptions, unitByIdQueryOptions } from '@/service/vpc/queryOptions';

export const loaderUnitMaintenanceProtocolPage = async (opts: LoaderOptions) => {
  const { endCustomerUnitId, protocolKey } = opts.params;

  if (!endCustomerUnitId || !protocolKey) {
    return;
  }

  // First fetch the unit data to get serial numbers and chassis IDs
  const unit = await opts.context.queryClient.ensureQueryData(unitByIdQueryOptions({ endCustomerUnitId }));

  if (!protocolKey) return;
  const serviceProtocol = await opts.context.queryClient.ensureQueryData(
    getServiceProtocolByKeyQueryOptions({ protocolKey })
  );

  return { unit, serviceProtocol };
};
